import React from "react";
import { useNavigate } from "react-router-dom";
import "./ConfirmCancelAppointment.css";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import ClientInformation from "../ClientInformation/ClientInformation";
import { useDispatch } from "react-redux";
import { applicationTitle } from "../../Redux/SetApplicationTitle";

const ConfirmCancelAppointment = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const doneHandler = () => {
    navigate("/home");
    window.scrollTo({ top: 10, behavior: "smooth" });
    dispatch(applicationTitle("global.documentTitle"));
  };

  const rescheduleHandler = () => {
    navigate("/reschedule-appointment");
    window.scrollTo({ top: 10, behavior: "smooth" });
  };

  return (
    <div id={"wb-cont"} className="confirm-cancel mainContainer">
      <div className="homeTitleContainer">
        <h1 id="title">{t("confirmCancelApp.title")}</h1>
      </div>
      <p>{t("confirmCancelApp.paragraphOne")}</p>
      <br />
      <div className="viewAppointmentButtonContainer">
        <button className="buttonStyling" onClick={doneHandler}>
          {t("confirmCancelApp.done")}
        </button>
      </div>
      <br />
    </div>
  );
};

export default ConfirmCancelAppointment;
